export default __webpack_public_path__ + "static/media/bg-valdano-bio-02.8723153e.jpg";